import { playStats } from 'amkit3-modules/utils/services/statistic/playstats'
import { webadonload, webadclick } from 'amkit3-modules/utils/services/statistic/hiido'
import { load, click } from 'amkit3-modules/utils/services/statistic/yygame'

import HuyaStatisticEvent from './statistic-event'

class AdStatistic {
  constructor(collector) {
    collector.on(HuyaStatisticEvent.AD_LOAD, () => {
      webadonload(collector.getAid(), '', window.location.href, new Date().valueOf(), collector.getPas(), document.referrer)
      load(collector.getCode(), collector.getAti(), collector.getAid(), collector.getMId(), collector.getSessionId())
    })
    collector.on(HuyaStatisticEvent.AD_CLICK, () => {
      webadclick(collector.getAid(), '', window.location.href, new Date().valueOf(), collector.getPas(), document.referrer)
      click(collector.getCode(), collector.getAti(), collector.getAid(), collector.getMId(), collector.getSessionId())
    })
    collector.on(HuyaStatisticEvent.AD_COMPLETE, () => {
      playStats(collector.getVid(), collector.getChannelId(), collector.getLaiyuanv3(), 'adplay', window.location.href, document.referrer, '', '')
    })
    collector.on(HuyaStatisticEvent.AD_ERROR, () => {
      playStats(collector.getVid(), collector.getChannelId(), collector.getLaiyuanv3(), 'ad_shield', window.location.href, document.referrer, '', '')
    })
    collector.on(HuyaStatisticEvent.AD_NONE, () => {
      playStats(collector.getVid(), collector.getChannelId(), collector.getLaiyuanv3(), 'ad_none', window.location.href, document.referrer, '', '')
    })
  }
}

export default AdStatistic
